module.exports = __webpack_public_path__ + "static/media/caristo_logo.ff22f321.svg";